export default {
  doReset () {
    this.$v.$touch()
    if (this.$v.$error) {
      return
    }
    // Fim da validação
    this.loading = true
    this.$http.post('/v1/auth/reset', this.reset)
      .then(({ data }) => {
        this.msg = null
        this.loading = false
        return this.$router.push({ name: 'auth.login' })
      }).catch((er) => {
        this.msg = er.meta.message
        this.loading = false
      })
  }
}



// WEBPACK FOOTER //
// ./src/app/auth/reset/resources/methods.js